import "~/../stylesheets/global.css"

import * as Turbo from "@hotwired/turbo"
import { Application } from "@hotwired/stimulus"

import { CurrencyController, CopyController, HamburgerController } from "../controllers"
import "../analytics"

window.Stimulus = Application.start()
Stimulus.register("currency", CurrencyController)
Stimulus.register("copy", CopyController)
Stimulus.register("hamburger", HamburgerController)
